<!--
  --
  -- 乗り捨てサービス選択シート
  --
  -->
<template>
  <c-base-sheet>
    <!-- ラベル -->
    <template #caption>{{caption}}</template>

    <!-- 説明 -->
    <template #description>
      <span v-html="returns.desc"/>
    </template>

    <!-- コンテンツ -->
    <template>
      <c-returns-input :returns="returns"/>
    </template>
  </c-base-sheet>
</template>

<script>
import CBaseSheet from '../CBaseSheet'
import CReturnsInput from './CReturnsInput'

export default {
  name: 'CReturnsSheet',

  components: {
    CBaseSheet,
    CReturnsInput
  },

  props: {
    caption: {
      type: String
    },
    returns: {
      type: Object,
      required: true
    }
  }
}
</script>
